// @ts-nocheck
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import icons from '../../../../constants/icons';

function Franchise({ option }) {
  return (
    <>
      <div className="game-img">
        <div className="icon-wrapper game">
          <FontAwesomeIcon icon={icons.GAME_FRANCHISE} className="game" />
        </div>
      </div>
      <div className="item-content">
        <span>{option.title}</span>
      </div>
    </>
  );
}
export default Franchise;
